(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  // Au mouseenter, on récupère la valeur de data-color-text et data-color-background et on l'applique à --color-text et --color-background
  document.addEventListener('DOMContentLoaded', function() {
    const collectionItems = document.querySelectorAll('.collection_item');
    const container = document.querySelector('.collection_list_wrapper');

    function isDesktop() {
      return window.innerWidth > 768;
    }

    function handleMouseover(item) {
      if (!isDesktop()) return;

      // on supprime la class active de tous les items
      collectionItems.forEach(function(item) {
        item.classList.remove('active');
      });
      // on ajoute la class active à l'item courant
      item.classList.add('active');
      container.style.setProperty('--text-color', item.dataset.colorText);
      container.style.setProperty('--background-color', item.dataset.colorBackground);
    }

    function handleScroll() {
      if (!isDesktop()) return;

      // Si la souris n'est pas sur un item, on reset les valeurs de --color-text et --color-background et on retire la class active de tous les items
      if (!document.querySelector('.collection_item:hover')) {
        container.style.setProperty('--text-color', '#8f5f00');
        container.style.setProperty('--background-color', '#e9ddc5');
        collectionItems.forEach(function(item) {
          item.classList.remove('active');
        });
      }
    }

    collectionItems.forEach(function(item) {
      item.addEventListener('mouseover', function() {
        handleMouseover(item);
      });
    });

    // Au scroll on reset les valeurs de --color-text et --color-background et on retire l'événement mouseenter
    window.addEventListener('scroll', handleScroll);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const text = new SplitText(".scrolling_text_content", {
    type: "words, chars",
  });

  let animationComplete = false;

  const isMobile = window.matchMedia("(max-width: 749px)").matches;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".scrolling_text_content",
      start: "top 50%",
      end: isMobile ? "+=200%" : "+=140%",
      scrub: 0.5,
    },
  }).to(text.chars, {
    duration: 0.3,
    color: "#8f5f00",
    stagger: 0.1,
  });
});


  } catch(e) { console.error(e); }
})();
})();
